import React from 'react'

export const FreeTrialBanner: React.FC = () => null
